import React, {useEffect, useState} from 'react'
import Pal from './Pal'
import fetchSideBarResponse from '../sidebarRequests';
import { ColorRing } from 'react-loader-spinner';

function MotivationSeeker({onClose, isVisible}) {
  
  const [helpContext, setHelpContext] = useState("");
  const [promptResponse, setPromptResponse] = useState("");
  const [displayQuestion, setDisplayQuestion]= useState(true);
  const [displayAnswer, setDisplayAnswer] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleGetMotivation = async() =>{
    document.getElementById('main-sidebar-button').disabled = true;
        if(helpContext === ""){
            alert("Please type an input");
            return;
        }
        setIsLoading(true);
        const response = await fetchSideBarResponse("motivate", helpContext);
        if(response){
            setIsLoading(false);
            setPromptResponse(response.response);
            setDisplayQuestion(false);
            setDisplayAnswer(true);
        }
  }

  const promptResponseRenderer = () => {
        if(promptResponse != ""){
            return <div dangerouslySetInnerHTML={{ __html: promptResponse }} />;
        }
        return
  }

  const handleClose= ()=> {
    handleRetry();
    onClose();
  }

  

  const handleRetry = ()=>{
    setDisplayAnswer(false);
    setDisplayQuestion(true);
  }
  return (
    <div id = "pal-body"  style={{ display: isVisible ? 'flex' : 'none' }}>
        <Pal/>
        {displayQuestion && <div id ="sidebar-question-container">
            <div id='pal-question'>
                Hey there! I'm here for you. Let me know what you're going through, and I'll do everything I can to offer support and motivation.
            </div>
            <div id='pal-option'>
                <textarea id="sidebar-response" onChange = {(e) =>setHelpContext(e.target.value)} className= "user-response"></textarea>
            </div>
            {isLoading && <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="blocks-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="blocks-wrapper"
                                    colors={[
                                    "#e15b64",
                                    "#f47e60",
                                    "#f8b26a",
                                    "#abbd81",
                                    "#849b87",
                                    ]}
                                />}
            <button class="form-submit-button" onClick= {handleGetMotivation} id='main-sidebar-button'>Motivate</button>
            <button class="form-submit-button" onClick= {handleClose} id='sidebar-button'>Close</button>
        </div>}
        { displayAnswer &&
            <div id="promptResponse">
                {promptResponseRenderer()}
                <button class="form-submit-button" onClick= {handleClose} id='sidebar-button-close'>Close</button>
                <button class="form-submit-button" onClick= {handleRetry} id='sidebar-button-retry'>Try Again</button>
             </div>
        }
    </div>
  )
}

export default MotivationSeeker;